import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Production from "@/pages/Production";
import Inventory from "@/pages/Inventory";
import SalesOrders from "@/pages/SalesOrders";
import Exchanges from "@/pages/Exchanges";
import Documents from "@/pages/Documents";
import QRDispatch from "@/pages/QRDispatch";
import Purchase from "@/pages/Purchase";
import Designs from "@/pages/Designs";
import Legal from "@/pages/Legal";
import Analytics from "@/pages/Analytics";
import Contacts from "@/pages/Contacts";
import Shipping from "@/pages/Shipping";
import AuditLogs from "@/pages/AuditLogs";
import IntegrationHealth from "@/pages/IntegrationHealth";
import WebsiteSimulator from "@/pages/WebsiteSimulator";
import Users from "@/pages/Users";
import Finance from "@/pages/Finance";
import AIAssistant from "@/pages/AIAssistant";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex items-center justify-center h-screen">
        <span className="label-eyebrow" data-testid="app-loading">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <AppLayout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="production" element={<Production />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="sales" element={<SalesOrders />} />
              <Route path="exchanges" element={<Exchanges />} />
              <Route path="documents" element={<Documents />} />
              <Route path="dispatch" element={<QRDispatch />} />
              <Route path="purchase" element={<Purchase />} />
              <Route path="designs" element={<Designs />} />
              <Route path="legal" element={<Legal />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="ai" element={<AIAssistant />} />
              <Route path="finance" element={<Finance />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="shipping" element={<Shipping />} />
              <Route path="audit" element={<AuditLogs />} />
              <Route path="integration" element={<IntegrationHealth />} />
              <Route path="simulator" element={<WebsiteSimulator />} />
              <Route path="users" element={<Users />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
